import axios, { AxiosInstance } from "axios";
import { api } from "../../host";
//@ts-ignore
const http: AxiosInstance = axios.create({
    baseURL: `${api}/`
})

export default http
